angular.module('webremote.dashboard').controller('tipModalCtrl', 
function ($scope, $uibModalInstance) {

    $scope.closeModal = function(){
        $uibModalInstance.close();
    };

});
